export default __webpack_public_path__ + "static/media/mlr-3-rMIN.bb105e8d.avif";